import { jsxs } from "react/jsx-runtime";
import * as RadixLabel from "@radix-ui/react-label";
import * as React from "react";
import { concat } from "../../utils/classNames.js";
import "../../utils/globals.js";
import { useArmstrongConfig } from "../config/config.context.js";
import "./label.theme.css.js";
const Label = React.forwardRef(({ required, className, requiredIndicator, children, displaySize, ...nativeProps }, ref) => {
  const globals = useArmstrongConfig({
    inputDisplaySize: displaySize,
    requiredIndicator
  });
  return jsxs(RadixLabel.Root, { className: concat("arm-label", className), ref, "data-size": globals.inputDisplaySize, ...nativeProps, children: [children, required && jsxs("span", { className: "arm-label-required-indicator", children: [" ", globals.requiredIndicator] })] });
});
Label.displayName = "Label";
export {
  Label
};
//# sourceMappingURL=label.component.js.map
